// extracted by mini-css-extract-plugin
export default {"relative":"KsIi1","hint":"gDWRJ","editButton":"X1Inr","dropzone":"SR5Qh","dropzoneActive":"jy3ZQ","hintIcon":"Y0GSQ","spinner":"xbbuo Y0GSQ","spinnerContainer":"OV743 Y0GSQ"};